import {
  CLEAR_BDO_SETTINGS,
  CREATE_BDO_SETTING,
  CREATE_BDO_SETTING_FAIL,
  CREATE_BDO_SETTING_SUCCESS,
  DELETE_BDO_SETTING,
  DELETE_BDO_SETTING_FAIL,
  DELETE_BDO_SETTING_SUCCESS,
  GET_BDO_SETTING,
  GET_BDO_SETTING_FAIL,
  GET_BDO_SETTING_SUCCESS,
  GET_BDO_SETTINGS,
  GET_BDO_SETTINGS_FAIL,
  GET_BDO_SETTINGS_SUCCESS,
  UPDATE_BDO_SETTING,
  UPDATE_BDO_SETTING_FAIL,
  UPDATE_BDO_SETTING_SUCCESS
} from './constants';

export const getBDOSettings = payload => {
  return {
    type: GET_BDO_SETTINGS,
    payload
  };
};

export const getBDOSettingsSuccess = payload => {
  return {
    type: GET_BDO_SETTINGS_SUCCESS,
    payload
  };
};

export const getBDOSettingsFail = error => {
  return {
    type: GET_BDO_SETTINGS_FAIL,
    error
  };
};

export const getBDOSetting = payload => {
  return {
    type: GET_BDO_SETTING,
    payload
  };
};

export const getBDOSettingSuccess = payload => {
  return {
    type: GET_BDO_SETTING_SUCCESS,
    payload
  };
};

export const getBDOSettingFail = error => {
  return {
    type: GET_BDO_SETTING_FAIL,
    error
  };
};

export const createBDOSetting = (payload, onSuccess, onError) => {
  return {
    type: CREATE_BDO_SETTING,
    payload,
    onSuccess,
    onError
  };
};

export const createBDOSettingSuccess = payload => {
  return {
    type: CREATE_BDO_SETTING_SUCCESS,
    payload
  };
};

export const createBDOSettingFail = error => {
  return {
    type: CREATE_BDO_SETTING_FAIL,
    error
  };
};

export const updateBDOSetting = (payload, onSuccess, onError) => {
  return {
    type: UPDATE_BDO_SETTING,
    payload,
    onSuccess,
    onError
  };
};

export const updateBDOSettingSuccess = payload => {
  return {
    type: UPDATE_BDO_SETTING_SUCCESS,
    payload
  };
};

export const updateBDOSettingFail = error => {
  return {
    type: UPDATE_BDO_SETTING_FAIL,
    error
  };
};

export const deleteBDOSetting = payload => {
  return {
    type: DELETE_BDO_SETTING,
    payload
  };
};

export const deleteBDOSettingSuccess = payload => {
  return {
    type: DELETE_BDO_SETTING_SUCCESS,
    payload
  };
};

export const deleteBDOSettingFail = error => {
  return {
    type: DELETE_BDO_SETTING_FAIL,
    error
  };
};

export const clearBDOSettings = () => {
  return {
    type: CLEAR_BDO_SETTINGS
  };
};
